import { IconSearch } from "@tabler/icons-react";
import type { ComponentPropsWithRef } from "react";
// @ts-expect-error pure js
import { classnames } from "../../utils";
import styles from "./SearchInput.module.css";

type SearchInputProps = Omit<ComponentPropsWithRef<"input">, "type">;

export default function SearchInput({ className, ...props }: SearchInputProps) {
  return (
    <div className={classnames(styles.search, className)}>
      <IconSearch size={20} className={styles.icon} aria-hidden="true" />
      <input type="search" className={styles.input} {...props} />
    </div>
  );
}
